import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";
import {
  LoginPageWrapper,
  Logo,
  Content,
  Layer,
  LoginCard,
  Input,
  Form,
  Label,
  InputGroup,
  FormGroup,
  ButtonWrapper,
  FooterWrapper,
  Button
} from "../styled";
import ErrorAlert from "../../components/error-alert/ErrorAlert";
import Footer from "../footer/Footer";
import { User } from "../../../types";
import { MAIN_PATH, CHANGE_PWD_SUCCESS_PATH } from "../../AppRoutes";

type ChangePasswordProps = {
  logoutSuccessful: () => void;
  user: User;
  requestChangePassword: (
    username: string,
    oldPassword: string,
    newPassword: string
  ) => Promise<any>;
  failureMessage: string;
  setFailureMessage: (message: string | null) => void;
  history: any;
  initiatePasswordChange: boolean;
};

type ChangePasswordState = {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  [x: number]: any;
  showSpinner: boolean;
  pwdChangeSuccessful: boolean;
};

export default class ChangePassword extends PureComponent<
  ChangePasswordProps,
  ChangePasswordState
> {
  static defaultProps = {
    failureMessage: ""
  };

  state = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    showSpinner: false,
    pwdChangeSuccessful: false
  };

  checkPasswords = () => {
    const { requestChangePassword, user, setFailureMessage } = this.props;
    const { oldPassword, newPassword, confirmNewPassword } = this.state;

    setFailureMessage("");
    if (newPassword === oldPassword) {
      setFailureMessage(
        "Your new password cannot be equal to your current password!"
      );
    } else if (newPassword !== confirmNewPassword) {
      setFailureMessage("Passwords do not match!");
    } else if (newPassword === confirmNewPassword) {
      requestChangePassword(user.username, oldPassword, newPassword)
        .then(() => this.setState({ pwdChangeSuccessful: true }))
        .catch(() => {
          setFailureMessage(
            "Your password does not match the MPS password policy."
          );
        });
    } else {
      setFailureMessage(
        "Your password does not match the MPS password policy."
      );
    }
  };

  handleInputChange = (event: any) => {
    const { target } = event;
    this.setState({ [target.name]: event.target.value });
  };

  keyPressed = (event: any) => {
    if (event.key === "Enter") {
      this.checkPasswords();
    }
  };

  render() {
    const { failureMessage, initiatePasswordChange } = this.props;
    const {
      oldPassword,
      newPassword,
      confirmNewPassword,
      showSpinner,
      pwdChangeSuccessful
    } = this.state;

    if (!initiatePasswordChange) {
      return <Redirect push to={MAIN_PATH} />;
    }

    if (pwdChangeSuccessful) {
      return <Redirect push to={CHANGE_PWD_SUCCESS_PATH} />;
    }

    return (
      <LoginPageWrapper>
        <Logo>
          <img src="/mps-logo.png" width="350" alt="Morgan Project Services" />
        </Logo>
        <Content>
          <Layer>
            <LoginCard>
              <Form autoComplete="off">
                <div
                  style={{
                    color: "#fff",
                    paddingBottom: "1.5rem",
                    fontSize: "1.125rem",
                    textAlign: "center"
                  }}
                >
                  Your passsword has expired. Please change it.
                </div>
                {failureMessage && <ErrorAlert>{failureMessage}</ErrorAlert>}
                <FormGroup className="form-group">
                  <InputGroup>
                    <Label className="col-sm-4 col-form-label">
                      OLD PASSWORD
                    </Label>
                    <Input
                      name="oldPassword"
                      type="password"
                      value={oldPassword}
                      aria-label="Password"
                      aria-describedby="password-icon"
                      required
                      autoFocus
                      onChange={this.handleInputChange}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup className="form-group">
                  <InputGroup>
                    <Label className="col-sm-4 col-form-label">
                      NEW PASSWORD
                    </Label>
                    <Input
                      id="confirm-password-field"
                      name="newPassword"
                      type="password"
                      value={newPassword}
                      aria-label="NewPassword"
                      aria-describedby="password-icon"
                      required
                      onChange={this.handleInputChange}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup className="form-group">
                  <InputGroup>
                    <Label className="col-sm-4 col-form-label">
                      CONFIRM NEW PASSWORD
                    </Label>
                    <Input
                      id="confirm-password-field"
                      name="confirmNewPassword"
                      type="password"
                      value={confirmNewPassword}
                      aria-label="ConfirmNewPassword"
                      aria-describedby="password-icon"
                      required
                      onChange={this.handleInputChange}
                      onKeyPress={this.keyPressed}
                    />
                  </InputGroup>
                </FormGroup>
                <div
                  style={{
                    color: "#fff",
                    fontSize: "0.9rem",
                    alignSelf: "center",
                    fontWeight: 300,
                    width: "100%"
                  }}
                >
                  For security reasons, your password must have a minimum length
                  of <span style={{ fontWeight: "bold" }}>8 characters</span>{" "}
                  and include at least{" "}
                  <span style={{ fontWeight: "bold" }}>three of the four</span>{" "}
                  available character types:
                  <ul>
                    <li>one capital letter (A-Z)</li>
                    <li>one lowercase letter (a-z) </li>
                    <li>one digit (0-9)</li>
                    <li>one symbol (!,$,@ etc.)</li>
                  </ul>
                  It cannot include your username.
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "1 1 auto",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    paddingTop: "0.5rem"
                  }}
                >
                  <ButtonWrapper>
                    <Button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.checkPasswords}
                      disabled={
                        oldPassword === "" ||
                        newPassword === "" ||
                        confirmNewPassword === ""
                      }
                    >
                      {showSpinner && (
                        <div
                          className="spinner-border spinner-border-sm"
                          style={{ marginRight: "0.5rem" }}
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}{" "}
                      SUBMIT
                    </Button>
                  </ButtonWrapper>
                </div>
              </Form>
            </LoginCard>
          </Layer>
        </Content>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </LoginPageWrapper>
    );
  }
}
